import {
  PreloadAllModules,
  provideRouter,
  Routes,
  withPreloading,
} from '@angular/router';
import { adminGuard } from 'src/app/core/guards/admin.guard';
import { authGuard } from 'src/app/core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'tabs/van',
    pathMatch: 'full',
  },
  {
    path: 'tabs',
    loadComponent: () =>
      import('./shell/tabs/tabs.page').then((m) => m.TabsPage),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'van',
        pathMatch: 'full',
      },
      {
        path: 'van',
        loadComponent: () =>
          import('./features/maintain/_workspace/pages/workspace/workspace.page').then(
            (m) => m.WorkspacePage
          ),
      },
      {
        path: 'events',
        loadComponent: () =>
          import('./features/social/events/pages/event-list/events-list.page').then(
            (m) => m.EventsListPage
          ),
      },
      {
        path: 'events/:id',
        loadComponent: () =>
          import('./features/social/events/pages/event-detail/event-detail.page').then(
            (m) => m.EventDetailPage
          ),
      },
      {
        path: 'packing-lists',
        loadComponent: () =>
          import(
            './features/plan/packing-lists/pages/packing-lists-index/packing-lists-index.page'
          ).then((m) => m.PackingListsIndexPage),
      },
      {
        path: 'packing-lists/:id',
        loadComponent: () =>
          import(
            './features/plan/packing-lists/pages/packing-list-detail/packing-list-detail.page'
          ).then((m) => m.PackingListDetailPage),
      },
    ],
  },
  {
    path: 'welcome',
    loadComponent: () =>
      import('./platform/accounts/welcome/welcome.page').then(
        (m) => m.WelcomePage
      ),
  },
  {
    path: 'vans',
    loadComponent: () =>
      import('./features/maintain/vans/pages/van-list/van-list.page').then(
        (m) => m.VanListPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'vans/:id',
    loadComponent: () =>
      import('./features/maintain/vans/pages/van-detail/van-detail.page').then(
        (m) => m.VanDetailPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'fuel/:id',
    loadComponent: () =>
      import('./features/maintain/fuel/pages/fuel-overview/fuel-overview.page').then(
        (m) => m.FuelOverviewPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'fuel/:id/logs',
    loadComponent: () =>
      import('./features/maintain/fuel/pages/fuel-logs/fuel-logs.page').then(
        (m) => m.FuelLogsPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'fuel/:id/reports',
    loadComponent: () =>
      import('./features/maintain/fuel/pages/fuel-reports/fuel-reports.page').then(
        (m) => m.FuelReportsPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'mileage/:id',
    loadComponent: () =>
      import(
        './features/maintain/mileage/pages/mileage-overview/mileage-overview.page'
      ).then(
        (m) => m.MileageOverviewPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'mileage/:id/logs',
    loadComponent: () =>
      import('./features/maintain/mileage/pages/mileage-logs/mileage-logs.page').then(
        (m) => m.MileageLogsPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'mileage/:id/reports',
    loadComponent: () =>
      import(
        './features/maintain/mileage/pages/mileage-reports/mileage-reports.page'
      ).then(
        (m) => m.MileageReportsPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'accounts/login',
    loadComponent: () =>
      import('./platform/accounts/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'accounts/register',
    loadComponent: () =>
      import('./platform/accounts/register/register.page').then(
        (m) => m.RegisterPage
      ),
  },
  {
    path: 'accounts/reset-password',
    loadComponent: () =>
      import('./platform/accounts/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage
      ),
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./platform/pages/about/about.page').then((m) => m.AboutPage),
    canActivate: [authGuard],
  },
  {
    path: 'premium',
    loadComponent: () =>
      import('./platform/pages/premium/premium.page').then(
        (m) => m.PremiumPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./platform/pages/legal/terms/terms.page').then(
        (m) => m.TermsPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import(
        './platform/pages/legal/privacy-policy/privacy-policy.page'
      ).then(
        (m) => m.PrivacyPolicyPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./platform/settings/settings.page').then((m) => m.SettingsPage),
    canActivate: [authGuard],
  },
  {
    path: 'admin/events',
    loadComponent: () =>
      import('./platform/admin/events/admin-events.page').then(
        (m) => m.AdminEventsPage
      ),
    title: 'Events Admin',
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./platform/admin/admin.page').then((m) => m.AdminPage),
    canActivate: [authGuard, adminGuard],
  },
];

export const appRouting = provideRouter(
  routes,
  withPreloading(PreloadAllModules)
);
